import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import { Dropdown, Form } from "semantic-ui-react";
import * as QUESTION_ACTIONS from '../../../../actions/questionActions'

export class QuestionSelectComponent extends Component {

	static defaultProps = {
		questions: [],
		sectionId: null,
		excludeId: null,
		selectedQuestionId: null,
		onQuestionSelectedChanged: (value) => { }
	}

	componentDidMount() {
        this.loadQuestions();
    }

    componentDidUpdate(previous) {
        if (previous.sectionId !== this.props.sectionId ||
            previous.questionaire?.id !== this.props.questionaire?.id ||
            previous.questionaire?.tenantId !== this.props.questionaire?.tenantId) this.loadQuestions();
    }

    loadQuestions() {
        const { sectionId, questionaire, fetchQuestionsAction } = this.props;
        if (sectionId && questionaire?.id && questionaire?.tenantId)
            fetchQuestionsAction(questionaire.id, sectionId, questionaire.tenantId);
    }

	questionList() {
		return [
			{ key: 'none', text: 'None', value: null },
			...this.props.questions.map((question) => ({
				key: question.id,
				text: question.question,
				value: question.id,
			}))
		];
	}

	updateSelectedQuestion(value) {
		this.props.onQuestionSelectedChanged(value);
	}

	render() {
		return (
			<Form.Field>
				<label>Depends on question (Optional): </label>
				<Dropdown
					placeholder='Select a question'
					value={this.props.selectedQuestionId ?? null}
					fluid
					selection
					search
					options={this.questionList()}
					onChange={(e, { value }) => {
						this.updateSelectedQuestion(value);
					}} />
			</Form.Field>
		);
	}

}

const mapStateToProps = (state, ownprops) => {
	return {
		questions: _.isEmpty(state.questions) ? [] : Object.values(state.questions).filter(question => question.sectionId === ownprops.sectionId && question.id !== ownprops.excludeId && question.status !== 'isDeleted')
	};
}

export default connect(
	// map state to props
	mapStateToProps,
	// map dispatch to props
	(dispatch, ownProps) => ({
		fetchQuestionsAction: (questionnaireId, sectionId, tenantId) => dispatch(QUESTION_ACTIONS.fetchQuestionsAction(questionnaireId, sectionId, tenantId)),
	})
)(QuestionSelectComponent);